module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAmBAMAAAC10Z+jAAAAAXNSR0IB2cksfwAAACpQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAChPOiAAAAA50Uk5TAD8gYO9Az//f4FCc0PAj8kHNAAAAsUlEQVR4nG3SsQ3CMBAF0C8hEFCyA6J1lwUYgI49YqFf0DACI2QEOloWYRdEDIn/+aey7l7s8/mAHfRbHE9YMWmw4w1nZoXkHQcq7cjhm8kKc0klgWnOCVQ6rStaLWda/TTlZfs/kEJ+IpRciFZcTIAFBTjSa4QjjXCkDQSe5CPGrHR72tNdnfZG7u62S66ftvPujexrune3E+JmadtMXQ+sm/m8AJtmkl/A8j1IEHvgA8HKX/dBmtqgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/compose-alert-exit@2x.png
// module id = 786
// module chunks = 0